export function userMayLogin(user) {
  if (!user) {
    return [false, "login_failed"];
  }
  if (user.is_blocked) {
    return [false, "blocked"];
  }
  if (!user.is_instructor) {
    return [false, "invalid_role"];
  }
  return [true];
}



// WEBPACK FOOTER //
// ./utils/auth.js